export const FORMA_FOLDER_ID_BACK = 'back';
export const IP_INN_LENGTH = 12;
